import React, {ReactElement} from 'react';
import {FormattedMessage} from 'react-intl';
import Header from 'components/header';
import Footer from 'components/footer';

import './styles.scss';

type Props = {
  hideSeparator?: boolean;
  children: ReactElement;
}

export const Layout = ({hideSeparator, children}: Props): JSX.Element => {
  return <div className={'layout'}>
    <a href="#main-content" className="skip-link">
      <FormattedMessage id={'gritx.common.skipToContent'} defaultMessage={'Skip to main content'}/>
    </a>
    <Header/>
    <main className={'main'} id="main-content">
      <div className="container">
        {children}
      </div>
    </main>
    <Footer hideSeparator={hideSeparator}/>
  </div>;
};
